var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-gray-500 flex-1 flex justify-center flex-col"},[_c('div',{staticClass:"text-4xl font-bold"},[_vm._v("403")]),_c('div',{staticClass:"text-xl font-semibold"},[_vm._v("ERROR")]),_c('div',{staticClass:"text-lg"},[_vm._v("You are not allowed to view this page")])])
}]

export { render, staticRenderFns }